import { createFileRoute } from '@tanstack/react-router';

import ActingDetails from '@/modules/actings/pages/ActingDetails';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/actings/$actingId/',
)({
  head: () => ({
    meta: [{ title: 'Detalhes da Execução' }],
  }),
  component: function ActingDetailsRoute() {
    const { actingId } = Route.useParams();

    return <ActingDetails actingId={actingId} />;
  },
});
